<template>
	<nta-dialog
		:show="compProps.show"
		:title="
			symbolsStore.GUILabel('4abcd541-88f6-432c-b1a1-4f01301fea38') + ': ' + alternisStore.clickedHighlightWord
		"
		max-title-width="80%"
		:symbol-lang="domainStore.languagePreference"
		height="auto"
		width="35em"
		@close="cancel()"
	>
		<template #default>
			<div style="max-height: 80vh">
				<v-tabs v-model="tab" color="primary" show-arrows grow class="mx-3">
					<v-tab v-for="topLevelDataobjectId in Object.keys(items)" :value="topLevelDataobjectId">
						<div style="display: block">
							<div>{{ dataobjectTerm(topLevelDataobjectId) }}</div>
							<div>
								<QuestionDataobjectIdentifier
									:dataobject="graphStore.instance.dataobject.byId(topLevelDataobjectId)!"
									:grey="false"
								/>
							</div>
						</div>
					</v-tab>
				</v-tabs>
				<v-window v-model="tab">
					<v-window-item
						v-for="topLevelDataobjectId in Object.keys(items)"
						:key="topLevelDataobjectId"
						:value="topLevelDataobjectId"
					>
						<AttributeModalItem
							v-for="attrId in items[topLevelDataobjectId]"
							:key="attrId"
							:attribute-id="attrId"
						/>
					</v-window-item>
				</v-window>
			</div>
		</template>
	</nta-dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useAlternisStore } from "../../../../store/alternis/index";
import { useGraphStore } from "../../../../store/graph";
import { useInstanceWorkspacesStore } from "../../../../store/i-workspace";
import { useSymbolsStore } from "../../../../store/symbols";
import { useDomainStore } from "../../../../store/domain";
import AttributeModalItem from "./AttributeModalItem.vue";
import QuestionDataobjectIdentifier from "../QuestionDataobjectIdentifier.vue";

const alternisStore = useAlternisStore();
const graphStore = useGraphStore();
const workspacesStore = useInstanceWorkspacesStore();
const symbolsStore = useSymbolsStore();
const domainStore = useDomainStore();

const emits = defineEmits(["done"]);
const compProps = defineProps<{
	show: boolean;
}>();

const tab = ref("");
const items = computed(() => {
	function topLevelParent(instanceDataobjectId: string) {
		if (workspacesStore.workspaceGraph.nodes.find((n) => n.id === instanceDataobjectId))
			return instanceDataobjectId;
		let p = graphStore.instance.dataobjects.find(
			(d) => d.hasA.includes(instanceDataobjectId) || d.composedBy.includes(instanceDataobjectId)
		);
		if (p) return topLevelParent(p.id);
		return instanceDataobjectId;
	}
	let i: { [topLevelDataobjectId: string]: string[] } = {};
	alternisStore.clickedHighlightAttributes.forEach((attrId) => {
		let attr = graphStore.instance.attribute.byId(attrId);
		if (!attr) return;
		let dataobjectId = attr.partOf;
		let topLevelDataobjectId = topLevelParent(dataobjectId);
		if (!i[topLevelDataobjectId]) i[topLevelDataobjectId] = [];
		i[topLevelDataobjectId].push(attrId);
	});
	return i;
});

function dataobjectTerm(dataobjectId: string) {
	let dataobject = graphStore.instance.dataobject.byId(dataobjectId);
	if (!dataobject) return "";
	let concept = graphStore.concept.dataobject.byId(dataobject.concept);
	if (!concept) return "";
	return symbolsStore.term({ id: concept.refersTo, terminology: concept.terminology });
}

function cancel() {
	emits("done");
}

watch(
	() => compProps.show,
	(show) => {
		if (!show) alternisStore.clickedHighlightAttributes = [];
	},
	{ immediate: true }
);
</script>
